import initialStore from './initialState'
import { IntegrationAction } from '../airbnb/actionNames'
import { IItemData } from '../../models/Booking'

export default function(
  store: Readonly<IIntegrationStore> = initialStore,
  action: any,
): IIntegrationStore {
  switch (action.type) {
    case IntegrationAction.SetBookingSettingsRedux:
      return {
        ...store,
        settings: action.payload.settings,
        mapping:
          action.payload.mappings &&
          action.payload.mappings.map(m => ({
            ...m,
            prices: m.prices ? m.prices.filter(p => Boolean(p.id)) : [],
          })),
      }
    case IntegrationAction.SetBookingRoomsRedux:
      return {
        ...store,
        rooms: action.payload.rooms,
      }
    case IntegrationAction.SetBookingStep:
      return {
        ...store,
        step: action.payload,
      }
    case IntegrationAction.SetTrobuledBookingRooms:
      return {
        ...store,
        troubledRooms: action.payload,
      }
    case IntegrationAction.BookingSavePriceConfiguration:
      return {
        ...store,
        bookingError: [],
        changed: true,
        mapping: store.mapping.map(m => {
          if (m.booking_id === action.payload.mapping.booking_id) {
            return {
              ...m,
              prices: m.prices.find(p => p.id === action.payload.pricing.id)
                ? m.prices.map(p => {
                    if (p.id === action.payload.pricing.id) {
                      return {
                        ...p,
                        settings: action.payload.settings,
                      }
                    } else {
                      return p
                    }
                  })
                : [
                    ...m.prices,
                    {
                      id: action.payload.pricing.id,
                      settings: action.payload.settings,
                    },
                  ],
            }
          }
          return m
        }),
      }
    case IntegrationAction.BookingDeletePricing:
      return {
        ...store,
        changed: true,
        mapping: store.mapping.map(m => {
          if (m.booking_id === action.payload.booking_room_id) {
            return {
              ...m,
              prices: m.prices.filter(p => p.id !== action.payload.id),
            }
          } else {
            return m
          }
        }),
      }
    case IntegrationAction.BookingSaveMappedRooms: {
      return {
        ...store,
        troubledRooms: [],
        changed: true,
        mapping: store.mapping.find(
          m =>
            action.payload.id && m.booking_id === action.payload.id.booking_id,
        )
          ? store.mapping.map((mappingItem: any) => {
              if (mappingItem.booking_id === action.payload.id.booking_id) {
                return {
                  ...mappingItem,
                  prices: [],
                  bed_booking_rooms: action.payload.rooms,
                }
              }
              return mappingItem
            })
          : [
              ...store.mapping,
              {
                booking_id: action.payload.room.id,
                bed_booking_rooms: action.payload.rooms,
                prices: [],
              },
            ],
      }
    }
    case IntegrationAction.BookingDeleteMapping:
      return {
        ...store,
        troubledRooms: [],
        changed: true,
        mapping: store.mapping.map((mapping: any) =>
          mapping.booking_id === action.payload.mapping.id
            ? {
                ...mapping,
                prices: [],
                bed_booking_rooms: mapping.bed_booking_rooms.filter(
                  (room: any) => room !== action.payload.room.id,
                ),
              }
            : mapping,
        ),
      }
    case IntegrationAction.SetBookingChanged:
      return {
        ...store,
        changed: action.payload,
      }
    case IntegrationAction.SetBookingErrorRooms:
      return {
        ...store,
        bookingError: action.payload,
      }
    case IntegrationAction.SetBookingStartRoomSync:
      return {
        ...store,
        settings: {
          ...store.settings,
          booking_import_reservations: action.payload,
        },
      }
    case IntegrationAction.SetBookingPricingInfo:
      return {
        ...store,
        pricingInfo: action.payload,
      }
    case 'FETCH_BOOKING_MULTI_SUCCESS':
      return {
        ...store,
        bookingObjects: action.payload,
        loading: false,
      }
    case 'FETCH_BOOKING_MULTI':
      return {
        ...store,
        loading: true,
      }
    case IntegrationAction.UnconfirmBookingConfiguration:
      return {
        ...store,
        settings: {
          ...store.settings,
          booking_integration_status: '1',
        },
      }
    case IntegrationAction.ConfirmBookingConfiguration:
      return {
        ...store,
        settings: {
          ...store.settings,
          booking_integration_status: '2',
        },
      }
    case IntegrationAction.ChangeBookingName:
      return {
        ...store,
        bookingObjects: store.bookingObjects.map((item: IItemData) => {
          if (item.id === action.payload.id_integration) {
            return {
              ...item,
              booking_object_name: action.payload.booking_object_name,
            }
          }
          return item
        }),
        settings: store.settings
          ? {
              ...store.settings,
              booking_object_name: action.payload.booking_object_name,
            }
          : store.settings,
      }
    case IntegrationAction.BookingDeleteProperty:
      return {
        ...store,
        bookingObjects: store.bookingObjects.filter(
          (item: IItemData) => item.id !== action.payload.id_integration,
        ),
      }
    case IntegrationAction.SetBookingTab:
      return {
        ...store,
        tab: action.payload,
      }
    case IntegrationAction.SetBookingPropertyValueTaken:
      return {
        ...store,
        isTaken: action.payload,
      }
    case IntegrationAction.SetBookingPropertyCheckLoading:
      return {
        ...store,
        propertyCheckLoading: action.payload,
      }
    case IntegrationAction.CheckBookingProperty:
      return {
        ...store,
        propertyCheckLoading: true,
      }
  }

  return store
}

export interface IIntegrationStore {
  settings: any | null
  mapping: any | null
  user: any | null
  rooms: any | null
  step: number
  changed: boolean
  bookingError: any
  troubledRooms: any
  pricingInfo: number
  tab: number
  loading: boolean
  bookingObjects: IItemData[]
  isTaken: boolean
  propertyCheckLoading: boolean
}
